import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { BaseService } from './base.service';

@Injectable()
export class GuidService extends BaseService {
  private guids: Array<string>;

  constructor(protected http: Http) {
    super(http);
    this.generateGuids();
  }

  public getGuid(): string {
    if (this.guids.length < 10) {
      this.generateGuids();
    }

    return this.guids.pop();
  }

  private async generateGuids() {
    this.guids = await this.get('guids');
  }
}



// WEBPACK FOOTER //
// ./src/app/services/guid.service.ts